export const uploadedVideo = {
  vehicle: "Vehicle",
  fleet: "Fleet",
  videoTime: "Time Started",
  duration: "Duration",
  uploadTime: "Time Uploaded",
  uploadStatus: "Upload Status",
  driver: "Driver",
  speed: "Speed",
  notes: "Notes",
  camera: "Camera",
  videoSize: "Video Size",
  download: "View",
  completed: "Completed",
  uploading: "Uploading",
  acquiring: "Acquiring",
  failed: "Failed",
  front: "Front",
  rear: "Rear",
  DSS: "DSS",
  left: "Left",
  right: "Right",
  partialDone: "Partial Done",
  // Format: type ["detail1", "detail2", ......]
  deleteTip:
    "The selected record will be deleted. Are you sure you want to proceed? | The selected records will be deleted. Are you sure you want to proceed?",
  invalidURL: "invalidURL",
};
